
































import Modal from "../core/Modals/Modal.vue";
import { JournalEntry } from "../models/JournalEntry";
import JournalFolderSelect from "../core/Forms/JournalFolderSelect.vue";
import { JournalApi } from "../api/JournalApi";

export default {
    name: "MoveEntryModal",
    components: { JournalFolderSelect, Modal },
    props: {
        entry: JournalEntry,
        showModal: Boolean,
    },
    data() {
        return {
            selectedFolder: null,
            saving: false,
            JournalApi: new JournalApi(),
        };
    },
    methods: {
        closeModal(): void {
            this.$emit("close-modal");
        },
        save(): void {
            let self = this;

            if (self.saving) {
                return;
            }
            if (!self.selectedFolder) {
                swal(
                    "Veuillez sélectionner un dossier de destination",
                    "",
                    "error"
                );
                return;
            }

            self.saving = true;
            self.entry.parent_id = self.selectedFolder.id;
            self.JournalApi.save(self.entry).then(function () {
                self.saving = false;
                self.closeModal();
            });
        },
    },
};
